export default __webpack_public_path__ + "static/media/refsocial.722242ae.svg";